import { createReducer } from 'reduxsauce';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { RequestResetPasswordTypes } from '../actions/RequestResetPasswordActions';
import { isValidEmail } from '../../services/Validation';

/* ------------- Initial Request Reset Password State ------------- */
export const INITIAL_STATE = Immutable({
  authenticating: false,
  showEmailError: false,
  email: '',
  session: null,
});

/* ------------- Reducers ------------- */
export const onRequest = (state) => state.merge({ authenticating: true });
export const onSendMailSuccess = (state) =>
  state.merge({ authenticating: false });
export const onLogout = () => INITIAL_STATE;
export const onEmailChange = (state, { email }) =>
  state.merge({ email, showEmailError: true });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [RequestResetPasswordTypes.SEND_MAIL_REQUEST]: onRequest,
  [RequestResetPasswordTypes.SEND_MAIL_SUCCESS]: onSendMailSuccess,
  [RequestResetPasswordTypes.GET_SESSION_REQUEST]: onRequest,
  [RequestResetPasswordTypes.EMAIL_CHANGED]: onEmailChange,
  [RequestResetPasswordTypes.LOGOUT]: onLogout,
});

/* ------------- Selectors ------------- */
export const isAuthenticating = (state) =>
  state.requesetResetPassword.authenticating;
export const getEmail = (state) => state.requesetResetPassword.email;
export const shouldShowEmailError = (state) =>
  state.requesetResetPassword.showEmailError;
export const getSession = (state) => state.requesetResetPassword.session;

// memoized
export const isAuthenticated = createSelector(
  getSession,
  (session) => session !== null && session.activated
);
export const getEmailError = createSelector(getEmail, (email) =>
  isValidEmail(email) ? '' : 'A valid email address is required'
);
export const canReset = createSelector(
  getEmailError,
  (emailError) => emailError.length === 0
);



// WEBPACK FOOTER //
// ./src/state/reducers/RequestResetPasswordReducer.js